// Durations of the automatic bingo sounds (static/bingo-aanet, served at /bingo/aanet/), in ms.
// Generated from the files with ffprobe (2026-09-30); the server schedules the announcements by them.
export const BINGO_SOUND_MS: Record<string, number> = {
  'B1': 794,
  'B2': 746,
  'B3': 701,
  'B4': 664,
  'B5': 712,
  'B6': 703,
  'B7': 805,
  'B8': 800,
  'B9': 786,
  'B10': 761,
  'B11': 930,
  'B12': 930,
  'B13': 916,
  'B14': 922,
  'B15': 900,
  'G46': 1309,
  'G47': 1292,
  'G48': 1347,
  'G49': 1336,
  'G50': 1273,
  'G51': 1315,
  'G52': 1340,
  'G53': 1241,
  'G54': 1332,
  'G55': 1220,
  'G56': 1187,
  'G57': 1352,
  'G58': 1420,
  'G59': 1354,
  'G60': 1127,
  'I16': 977,
  'I17': 1174,
  'I18': 1171,
  'I19': 1163,
  'I20': 1114,
  'I21': 1234,
  'I22': 1346,
  'I23': 1254,
  'I24': 1182,
  'I25': 1268,
  'I26': 1352,
  'I27': 1491,
  'I28': 1538,
  'I29': 1515,
  'I30': 1344,
  'N31': 1140,
  'N32': 1121,
  'N33': 1167,
  'N34': 1340,
  'N35': 1243,
  'N36': 1250,
  'N37': 1339,
  'N38': 1296,
  'N39': 1335,
  'N40': 1043,
  'N41': 1105,
  'N42': 1046,
  'N43': 1115,
  'N44': 1203,
  'N45': 1246,
  'O61': 1508,
  'O62': 1231,
  'O63': 1169,
  'O64': 1291,
  'O65': 1306,
  'O66': 1358,
  'O67': 1381,
  'O68': 1482,
  'O69': 1712,
  'O70': 1513,
  'O71': 1628,
  'O72': 1794,
  'O73': 1705,
  'O74': 1660,
  'O75': 1741,
  'alkaa-1min': 3291,
  'alkaa-5min': 2691,
  'alkaa-10min': 2926,
  'alku': 3004,
  'alkumusiikki': 60003,
  'bingo': 1254,
  'fanfaari': 4488,
  'ilmoittautuminen-suljettu': 2456,
  'jaettu': 4258,
  'jackpot-kaytossa': 7453,
  'jackpot-mahdollinen': 2907,
  'jackpot': 3891,
  'jackpot-ohi': 3347,
  'jatketaan': 1280,
  'loppu': 3892,
  'melkein': 2508,
  'myohassa': 1933,
  'ohjeet': 69956,
  'oikein': 1489,
  'onnea': 1620,
  'onnea-monta': 1933,
  'peruttu': 3762,
  'rivi1': 1567,
  'rivi2': 1672,
  'rivi3': 1802,
  'rivi4': 2873,
  'seuraava': 1515,
  'seuraava-peli': 2743,
  'tarkistus': 1698,
  'tauko': 1802,
  'taustamusiikki': 29127,
  'taysi': 2691,
  'tervetuloa': 2534,
  'vaarin': 2821,
  'viimeinen': 2508,
};
